import React from 'react';
import LegalPageLayout, { LegalSub, LegalContact } from '../components/legal/LegalPageLayout';

const NdaPage = () => {
  const sections = [
    {
      id: 'purpose',
      title: 'Purpose and Scope',
      body: (
        <>
          <p>This Non-Disclosure Agreement ("NDA") governs the disclosure of confidential and proprietary information by Fortschritt Medical Supplies Inc. ("Disclosing Party") to healthcare professionals, medical institutions, and business partners ("Receiving Party") in accordance with Philippine laws, including the Trade Secrets Act provisions under Republic Act No. 10372 (Intellectual Property Code Amendment).</p>
          <p>This NDA applies to all technical data, product specifications, pricing information, clinical studies, and business strategies shared in connection with FlexiOss® bone regenerative products.</p>
        </>
      ),
    },
    {
      id: 'definition',
      title: 'Definition of Confidential Information',
      body: (
        <>
          <p>"Confidential Information" includes, but is not limited to:</p>
          <ul className="premium-list space-y-2.5">
            <li>Product formulations, compositions, and manufacturing processes</li>
            <li>Unpublished clinical trial data and research findings</li>
            <li>Pricing structures, volume discounts, and commercial terms</li>
            <li>Marketing strategies and sales projections</li>
            <li>Customer lists and distributor networks</li>
            <li>Technical specifications and quality control procedures</li>
            <li>Proprietary software, databases, and digital assets</li>
            <li>Business plans, financial data, and strategic initiatives</li>
          </ul>
          <p>Information marked as "Confidential," "Proprietary," or "For Professional Use Only" shall be presumed confidential. Oral disclosures identified as confidential at the time of disclosure are also covered.</p>
        </>
      ),
    },
    {
      id: 'obligations',
      title: 'Obligations of Receiving Party',
      body: (
        <>
          <p>The Receiving Party agrees to:</p>
          <LegalSub>3.1 Non-Disclosure</LegalSub>
          <p>Hold all Confidential Information in strict confidence and not disclose it to any third party without prior written consent from Fortschritt Medical Supplies Inc.</p>
          <LegalSub>3.2 Limited Use</LegalSub>
          <p>Use Confidential Information solely for the purpose of evaluating business opportunities with Fortschritt Medical Supplies Inc. or for legitimate medical/clinical purposes related to patient care.</p>
          <LegalSub>3.3 Protection Measures</LegalSub>
          <p>Implement reasonable security measures to protect Confidential Information from unauthorized access, disclosure, or use, including physical, electronic, and procedural safeguards.</p>
          <LegalSub>3.4 Authorized Personnel</LegalSub>
          <p>Limit access to Confidential Information to employees, contractors, or advisors who have a legitimate need to know and who are bound by confidentiality obligations.</p>
        </>
      ),
    },
    {
      id: 'exceptions',
      title: 'Exceptions to Confidentiality',
      body: (
        <>
          <p>Confidential Information does not include information that:</p>
          <ul className="premium-list space-y-2.5">
            <li>Is or becomes publicly available through no breach of this NDA</li>
            <li>Was rightfully in the Receiving Party's possession prior to disclosure</li>
            <li>Is independently developed by the Receiving Party without use of Confidential Information</li>
            <li>Is rightfully obtained from a third party without confidentiality restrictions</li>
            <li>Is required to be disclosed by law, court order, or regulatory authority (with prompt notice to Disclosing Party)</li>
          </ul>
        </>
      ),
    },
    {
      id: 'duration',
      title: 'Duration of Confidentiality',
      body: (
        <p>The obligations under this NDA shall remain in effect for a period of five (5) years from the date of disclosure, unless otherwise terminated in writing by both parties. Trade secrets shall remain confidential for as long as they qualify as trade secrets under Philippine law.</p>
      ),
    },
    {
      id: 'return',
      title: 'Return of Confidential Information',
      body: (
        <p>Upon request by the Disclosing Party, or upon termination of business discussions, the Receiving Party shall promptly return or destroy all Confidential Information (including copies and derivatives) and certify such destruction in writing.</p>
      ),
    },
    {
      id: 'remedies',
      title: 'Remedies for Breach',
      body: (
        <>
          <p>The Receiving Party acknowledges that unauthorized disclosure or use of Confidential Information may cause irreparable harm to the Disclosing Party. In addition to any other remedies available at law or equity, the Disclosing Party shall be entitled to seek injunctive relief and specific performance.</p>
          <p>Violations may also constitute unfair competition under Philippine law (Articles 28 and 168 of the Intellectual Property Code) and may subject the violator to civil and criminal liability.</p>
        </>
      ),
    },
    {
      id: 'governing-law',
      title: 'Governing Law',
      body: (
        <p>This NDA shall be governed by and construed in accordance with the laws of the Republic of the Philippines. Any disputes shall be subject to the exclusive jurisdiction of the courts of Pasig City, Metro Manila.</p>
      ),
    },
    {
      id: 'contact',
      title: 'Contact for NDA Inquiries',
      body: <LegalContact intro="For questions regarding this Non-Disclosure Agreement or to request a formal NDA execution:" />,
    },
  ];

  return (
    <LegalPageLayout
      testId="nda-page"
      title="Non-Disclosure Agreement"
      subtitle="Confidentiality and proprietary information protection for FlexiOss® technical, clinical and commercial data."
      sections={sections}
    />
  );
};

export default NdaPage;
